(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6375],{

/***/ 64815:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/state/[state]",
      function () {
        return __webpack_require__(15115);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ isBuyDirectEligible; }
/* harmony export */ });
/**
 * Determines if a property is eligible for buy-direct features. Property must
 * have BUY_DIRECT_ELIGIBLE tag (set by backend based on BUY_DIRECT_MARKETS).
 *
 * @param property - The property to check
 * @returns true if buy-direct features should be shown for this property
 */ var isBuyDirectEligible = function(property) {
    var ref;
    var ref1;
    // Market gate (respects BUY_DIRECT_MARKETS from backend)
    return (ref1 = (ref = property.listingTags) === null || ref === void 0 ? void 0 : ref.includes("BUY_DIRECT_ELIGIBLE")) !== null && ref1 !== void 0 ? ref1 : false;
};


/***/ }),

/***/ 95707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Dm": function() { return /* reexport */ formatStreetAddress; },
  "pX": function() { return /* reexport */ buyDirectHelpers/* isBuyDirectEligible */.p; },
  "O8": function() { return /* reexport */ usePropertyReactions; },
  "FZ": function() { return /* reexport */ useSellerDisclosures; },
  "n6": function() { return /* reexport */ useSimilarProperties; },
  "ad": function() { return /* reexport */ useTrackProperty/* useTrackProperty */.a; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/__generated__/protobuf/journey/data/categories/marketplace_property_category.ts
var marketplace_property_category = __webpack_require__(46329);
// EXTERNAL MODULE: ./src/components/api/index.ts + 2 modules
var api = __webpack_require__(67945);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var useTrackProperty = __webpack_require__(97997);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 57 modules
var observability = __webpack_require__(49048);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/usePropertyReactions.ts









var redirectToLogin = function(addressId) {
    var url = new URL(window.location.toString());
    url.searchParams.append("likedId", addressId);
    window.location.assign("/login?redirectTo=".concat(encodeURIComponent(url.toString())));
    return;
};
var initialState = {
    isDisliked: false,
    isLiked: false,
    isLoading: false
};
var checkIfLiked = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(addressToken) {
        var ref, res, ref1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!addressToken) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertyReaction({
                            addressToken: addressToken
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (ref1 = (ref = res.marketplace.property) === null || ref === void 0 ? void 0 : ref.isLiked) !== null && ref1 !== void 0 ? ref1 : false
                    ];
                case 2:
                    return [
                        2,
                        false
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function checkIfLiked(addressToken) {
        return _ref.apply(this, arguments);
    };
}();
var likeProperty = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(addressId, customerId, source) {
        var e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().SetMarketplacePropertyReaction({
                            input: {
                                addressId: addressId,
                                customerId: customerId,
                                reaction: "REACTION_LIKE",
                                source: source
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function likeProperty(addressId, customerId, source) {
        return _ref.apply(this, arguments);
    };
}();
var unlikeProperty = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(addressId, customerId) {
        var e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().RemoveMarketplacePropertyReaction({
                            input: {
                                addressId: addressId,
                                customerId: customerId
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        false
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function unlikeProperty(addressId, customerId) {
        return _ref.apply(this, arguments);
    };
}();
var usePropertyReactions = function(addressId) {
    var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "REACTION_SOURCE_WEB_PDP";
    var ref = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref.authentication, user = ref.user;
    var router = (0,next_router.useRouter)();
    var isLoggedIn = authentication.state === "authenticated";
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var likedIdExists = router.query["likedId"] === addressId;
    var onFinishLikedId = function() {
        delete router.query["likedId"];
        router.replace({
            query: router.query
        }, undefined, {
            shallow: true
        });
    };
    (0,react.useEffect)(function() {
        if (!isLoggedIn || !addressId) {
            return;
        }
        if (likedIdExists && (user === null || user === void 0 ? void 0 : user.customerUuid)) {
            dispatch({
                type: "START_TOGGLE_FAVORITE"
            });
            likeProperty(addressId, user === null || user === void 0 ? void 0 : user.customerUuid, source).then(function(res) {
                dispatch({
                    type: "SET_FAVORITE",
                    payload: {
                        isLiked: res
                    }
                });
            }).finally(function() {
                onFinishLikedId();
            });
            return;
        }
        checkIfLiked(addressId).then(function(res) {
            dispatch({
                type: "SET_FAVORITE",
                payload: {
                    isLiked: res
                }
            });
        });
    }, [
        isLoggedIn,
        likedIdExists
    ]);
    var reducer = function(state, action) {
        switch(action.type){
            case "START_TOGGLE_FAVORITE":
                if (state.isLiked) {
                    return {
                        isLiked: false,
                        isLoading: true,
                        isDisliked: false
                    };
                }
                return {
                    isLiked: true,
                    isLoading: true,
                    isDisliked: false
                };
            case "SET_FAVORITE":
                return {
                    isLiked: action.payload.isLiked,
                    isLoading: false,
                    isDisliked: false
                };
        }
    };
    var ref1 = (0,react.useReducer)(reducer, initialState), state = ref1[0], dispatch = ref1[1];
    var onClickReaction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var trackingLabel, propertyReaction, reactionLabel, _tmp, _tmp1, onClickReactionEvent;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!addressId) {
                        return [
                            2
                        ];
                    }
                    if (!isLoggedIn && addressId) {
                        trackProperty("property-favorite", "redirect-to-login");
                        return [
                            2,
                            redirectToLogin(addressId)
                        ];
                    }
                    dispatch({
                        type: "START_TOGGLE_FAVORITE"
                    });
                    trackingLabel = state.isLiked ? "remove-favorite" : "add-favorite";
                    propertyReaction = state.isLiked ? unlikeProperty : likeProperty;
                    reactionLabel = state.isLiked ? marketplace_property_category/* MarketplacePropertyCategory_ReactionEventReaction.REACTION_REMOVE_LIKE */.AJ.REACTION_REMOVE_LIKE : marketplace_property_category/* MarketplacePropertyCategory_ReactionEventReaction.REACTION_ADD_LIKE */.AJ.REACTION_ADD_LIKE;
                    if (!(user === null || user === void 0 ? void 0 : user.customerUuid)) return [
                        3,
                        2
                    ];
                    _tmp = {
                        type: "SET_FAVORITE"
                    };
                    _tmp1 = {};
                    return [
                        4,
                        propertyReaction(addressId, user === null || user === void 0 ? void 0 : user.customerUuid, source)
                    ];
                case 1:
                    dispatch.apply(void 0, [
                        (_tmp.payload = (_tmp1.isLiked = _state.sent(), _tmp1), _tmp)
                    ]);
                    trackProperty("property-favorite", trackingLabel);
                    trackJourneyEvent("marketplaceProperty", "reaction", {
                        addressUuid: addressId,
                        reaction: reactionLabel,
                        source: source ? source : "marketplace-pdp"
                    });
                    onClickReactionEvent = new Event("propertyReactionEvent");
                    window.dispatchEvent(onClickReactionEvent);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        state.isLiked,
        isLoggedIn,
        user
    ]);
    return {
        onClickReaction: onClickReaction,
        isLiked: state.isLiked,
        isLoading: state.isLoading
    };
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSimilarProperties.ts


var useSimilarProperties = function(addressToken) {
    var ref = (0,react.useState)(), similarProperties = ref[0], setSimilarProperties = ref[1];
    (0,react.useEffect)(function() {
        if (!addressToken) {
            return;
        }
        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertySimilarProperties({
            addressToken: addressToken
        }).then(function(data) {
            var ref, ref1;
            setSimilarProperties(data === null || data === void 0 ? void 0 : (ref = data.marketplace) === null || ref === void 0 ? void 0 : (ref1 = ref.property) === null || ref1 === void 0 ? void 0 : ref1.similarProperties);
        });
    }, [
        addressToken
    ]);
    return {
        similarProperties: similarProperties
    };
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSellerDisclosures.ts


var useSellerDisclosures = function(addressToken) {
    var ref = (0,react.useState)(), sellerDisclosures = ref[0], setSellerDisclosures = ref[1];
    (0,react.useEffect)(function() {
        if (!addressToken) {
            return;
        }
        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertySellerDisclosures({
            addressToken: addressToken
        }).then(function(data) {
            var ref, ref1;
            setSellerDisclosures(data === null || data === void 0 ? void 0 : (ref = data.marketplace) === null || ref === void 0 ? void 0 : (ref1 = ref.property) === null || ref1 === void 0 ? void 0 : ref1.sellerDisclosuresDownloadUrl);
        });
    }, [
        addressToken
    ]);
    return {
        sellerDisclosures: sellerDisclosures
    };
};

// EXTERNAL MODULE: ./src/components/marketplace/helpers/buyDirectHelpers.ts
var buyDirectHelpers = __webpack_require__(63149);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/addressHelpers.ts
/**
 * Formats a street address with unit type and number if available.
 * @param street - The street address
 * @param unitType - Optional unit type (e.g., "Apt", "Unit", "Suite")
 * @param unitNumber - Optional unit number
 * @returns Formatted street address with unit information, or null if street is not provided
 */ function formatStreetAddress(street, unitType, unitNumber) {
    if (!street) {
        return null;
    }
    if (unitType && unitNumber) {
        return "".concat(street, " ").concat(unitType, " ").concat(unitNumber);
    }
    if (unitNumber) {
        return "".concat(street, " #").concat(unitNumber);
    }
    return street;
}

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/index.ts








/***/ }),

/***/ 97997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PropertyAnalytics; },
/* harmony export */   "a": function() { return /* binding */ useTrackProperty; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95674);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49048);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35480);
/* harmony import */ var _shared_trackers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59431);







var initialPropertyContext = {
    property: undefined
};
var PropertyAnalytics = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialPropertyContext);
var usePropertyAnalytics = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PropertyAnalytics);
};
/**
 * Geenerate the payload for the trackProperty function, exported for testing
 */ function buildPayload(property) {
    var additionalContextualData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, user = arguments.length > 2 ? arguments[2] : void 0;
    var trackPropertyFields = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (property === null || property === void 0 ? void 0 : property.city) && {
        city: property === null || property === void 0 ? void 0 : property.city
    }, (property === null || property === void 0 ? void 0 : property.state) && {
        state: property === null || property === void 0 ? void 0 : property.state
    }, (property === null || property === void 0 ? void 0 : property.zip) && {
        zip: property === null || property === void 0 ? void 0 : property.zip
    }, (property === null || property === void 0 ? void 0 : property.slug) && {
        slug: property === null || property === void 0 ? void 0 : property.slug
    }, (property === null || property === void 0 ? void 0 : property.addressToken) && {
        addressToken: property === null || property === void 0 ? void 0 : property.addressToken
    }, (property === null || property === void 0 ? void 0 : property.listingState) && {
        listingState: property === null || property === void 0 ? void 0 : property.listingState
    }, (property === null || property === void 0 ? void 0 : property.canSelfTour) && {
        canSelfTour: property === null || property === void 0 ? void 0 : property.canSelfTour
    });
    var properties = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, additionalContextualData, trackPropertyFields), {
        anonymousId: (0,_shared_trackers__WEBPACK_IMPORTED_MODULE_4__/* .getAnonymousId */ .y)()
    }), (user === null || user === void 0 ? void 0 : user.customerUuid) && {
        customerId: user.customerUuid
    });
    // Filter out any keys where the value is empty
    var payload = Object.keys(properties).filter(function(key) {
        return properties[key];
    }).reduce(function(obj, key) {
        obj[key] = properties[key];
        return obj;
    }, {});
    return payload;
}
var useTrackProperty = function() {
    var analytics = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_2__/* .useObservability */ .C3)();
    var property = usePropertyAnalytics().property;
    var user = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)().user;
    var trackProperty = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(featureName, label) {
        var additionalContextualData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var action = featureName;
        var payload = buildPayload(property, additionalContextualData, user);
        analytics.trackEvent(action, label, payload);
        if (_globals__WEBPACK_IMPORTED_MODULE_3__/* .DEPLOY_ENV */ .Zp === "development") {
            console.debug("[Analytics]", {
                featureName: featureName,
                label: label,
                payload: payload
            });
        }
    }, [
        analytics.trackEvent,
        property
    ]);
    return {
        trackProperty: trackProperty
    };
};


/***/ }),

/***/ 72199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SimilarListings; },
/* harmony export */   "d": function() { return /* binding */ ListingCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25923);
/* harmony import */ var _opendoor_cinderblocks_marketplace_PropertyCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36916);
/* harmony import */ var components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95707);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35480);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38298);









// This hook is used to lazy load the photo URL when the component is in view
// It uses the Intersection Observer API to detect when the component is in the viewport
// and sets the photo URL to be loaded only then
// This helps in optimizing performance by not loading images that are not visible to the user
// and reduces the initial load time of the component
var useLazyLoadPhoto = function(photoUrl) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!containerRef.current || isLoaded) return;
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setIsLoaded(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        isLoaded
    ]);
    return {
        containerRef: containerRef,
        loadedPhotoUrl: isLoaded ? photoUrl : null
    };
};
var ListingCard = function(param) {
    var utmSource = param.utmSource, utmMedium = param.utmMedium, utmCampaign = param.utmCampaign, utmContent = param.utmContent, utmTerm = param.utmTerm, listing = param.listing;
    var ref;
    var ref1 = (0,components_marketplace_helpers__WEBPACK_IMPORTED_MODULE_2__/* .usePropertyReactions */ .O8)(listing === null || listing === void 0 ? void 0 : listing.addressToken, "REACTION_SOURCE_WEB_PDP"), isLiked = ref1.isLiked, onClickReaction = ref1.onClickReaction;
    var photoUrl = "".concat(listing === null || listing === void 0 ? void 0 : (ref = listing.photos) === null || ref === void 0 ? void 0 : ref[0], "?").concat(new URLSearchParams({
        service: "cosmos",
        preset: "3:2-md",
        presetScale: "2/3",
        dpr: "1"
    }).toString()) || null;
    var ref2 = useLazyLoadPhoto(photoUrl), containerRef = ref2.containerRef, loadedPhotoUrl = ref2.loadedPhotoUrl;
    var ref3;
    var link = "".concat(_globals__WEBPACK_IMPORTED_MODULE_3__/* .COSMOS_URL */ .EQ, "/properties/").concat((ref3 = listing === null || listing === void 0 ? void 0 : listing.slug) !== null && ref3 !== void 0 ? ref3 : "_", "/aid_").concat(listing === null || listing === void 0 ? void 0 : listing.addressToken, "?").concat(new URLSearchParams((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, utmSource && {
        utm_source: utmSource
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmContent && {
        utm_content: utmContent
    }, utmTerm && {
        utm_term: utmTerm
    })).toString());
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_cinderblocks_marketplace_PropertyCard__WEBPACK_IMPORTED_MODULE_1__/* .PropertyCard */ .J, {
            baths: listing === null || listing === void 0 ? void 0 : listing.baths,
            beds: listing === null || listing === void 0 ? void 0 : listing.beds,
            city: listing === null || listing === void 0 ? void 0 : listing.city,
            dwellingType: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .convertDwellingType */ .F)(listing === null || listing === void 0 ? void 0 : listing.dwellingType),
            estimatedMonthlyPayment: listing === null || listing === void 0 ? void 0 : listing.estimatedMonthlyPayment,
            href: link,
            isFavorite: isLiked,
            neighborhood: listing === null || listing === void 0 ? void 0 : listing.neighborhood,
            onFavoritePress: onClickReaction,
            photoUrl: loadedPhotoUrl,
            price: listing === null || listing === void 0 ? void 0 : listing.listPrice,
            sqft: listing === null || listing === void 0 ? void 0 : listing.livingSquareFootage
        })
    });
};
var DISPLAYED_LISTING_SET_COUNT = 6;
var SimilarListings = function(param) {
    var listings = param.listings, title = param.title, utmSource = param.utmSource, utmMedium = param.utmMedium, utmCampaign = param.utmCampaign, utmContent = param.utmContent, utmTerm = param.utmTerm;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(DISPLAYED_LISTING_SET_COUNT), 2), displayedListingCount = ref[0], setDisplayedListingCount = ref[1];
    var incrementDisplayedListingCount = function() {
        setDisplayedListingCount(function(prev) {
            return prev + DISPLAYED_LISTING_SET_COUNT;
        });
    };
    var similarListings = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return listings.filter(function(_, index) {
            return index < displayedListingCount;
        }).map(function(listing, index) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                mb: 24,
                $largerThanXS: {
                    width: "100%"
                },
                $largerThanSM: {
                    width: "100%"
                },
                $largerThanMD: {
                    width: "48%"
                },
                $largerThanLG: {
                    width: "48%"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ListingCard, {
                    listing: listing,
                    utmSource: utmSource,
                    utmMedium: utmMedium,
                    utmCampaign: utmCampaign,
                    utmContent: utmContent,
                    utmTerm: utmTerm
                })
            }, index);
        });
    }, [
        listings,
        displayedListingCount
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        flexDirection: "column",
        $smallerThanMD: {
            paddingBottom: "$62x"
        },
        $largerThanSM: {
            paddingBottom: "$12x"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                tag: "h5",
                typography: "$subheaderXsmall",
                color: "$contentPrimary",
                mb: "$12x",
                children: title || "Similar listings"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                flexWrap: "wrap",
                justifyContent: "space-between",
                $largerThanXS: {
                    flexDirection: "column"
                },
                $largerThanSM: {
                    flexDirection: "column"
                },
                $largerThanMD: {
                    flexDirection: "row"
                },
                $largerThanLG: {
                    flexDirection: "row"
                },
                children: similarListings
            }),
            displayedListingCount < listings.length && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                onPress: incrementDisplayedListingCount,
                variant: "secondary",
                size: "small",
                analyticsName: "marketplace-show-more-listings",
                label: "See more homes"
            })
        ]
    });
};


/***/ }),

/***/ 38298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ convertDwellingType; }
/* harmony export */ });
/* unused harmony export formatPrettyTimeRange */
var TWELVE_HOURS = 12;
var convertDwellingType = function(dwellingType) {
    switch(dwellingType){
        case "SINGLE_FAMILY":
            return "Single family";
        case "TOWNHOUSE":
            return "Townhouse";
        case "CONDO":
            return "Condo";
        case "MULTI_FAMILY":
            return "Multi family";
        case "OTHER":
            return "Other";
        default:
            return "Other";
    }
};
var formatHours = function(date) {
    var hour = date.getHours();
    var isAm = hour < TWELVE_HOURS;
    if (hour > TWELVE_HOURS) {
        hour -= TWELVE_HOURS;
    }
    var openSuffix = isAm ? "AM" : "PM";
    return "".concat(hour).concat(openSuffix);
};
var formatPrettyTimeRange = function(start, end) {
    var weekday = start.toLocaleDateString([], {
        weekday: "short"
    });
    var month = start.toLocaleDateString([], {
        month: "short"
    });
    var date = start.getDate();
    var startTime = formatHours(start);
    var endTime = formatHours(end);
    return "".concat(weekday, " ").concat(month, " ").concat(date, ", ").concat(startTime, " - ").concat(endTime);
};


/***/ }),

/***/ 63631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ MAPBOX_ACCESS_TOKEN; },
/* harmony export */   "HP": function() { return /* binding */ OD_APP_URL; },
/* harmony export */   "Hx": function() { return /* binding */ MAPBOX_MAP_STYLE; },
/* harmony export */   "j_": function() { return /* binding */ HOMEPAGE_URL; }
/* harmony export */ });
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35480);

var HOMEPAGE_URL = {
    production: "https://www.opendoor.com",
    staging: "https://demo.simplersell.com",
    qa: "https://demo.simplersell.com",
    development: "http://localhost:3011/homepage-2019",
    test: "https://www.opendoor.com"
}[_components_globals__WEBPACK_IMPORTED_MODULE_0__/* .DEPLOY_ENV */ .Zp];
// Public token; meant to be exposed client-side.
// URL restrictions are configured in the Mapbox admin panel.
var MAPBOX_ACCESS_TOKEN = "pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tbndmMnpoMDgwNzJzb3Jtdm5wejJpMiJ9.9hm2Ma2vzjbr5Tr4nt4hmA";
var MAPBOX_MAP_STYLE = "mapbox://styles/opendoor/cktkqasmc1gbe17pfo2cm7ybb";
var getIsIOS = function() {
    var userAgent = typeof navigator !== "undefined" && (navigator.userAgent || navigator.vendor);
    return userAgent && /iPad|iPhone|iPod/.test(userAgent);
};
var platform = getIsIOS() ? "ios" : "android";
var OD_APP_URL = {
    ios: "https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8",
    android: "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en"
}[platform];


/***/ }),

/***/ 15115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _state_; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/properties/shared/MarketplaceMapLayout.tsx
var MarketplaceMapLayout = __webpack_require__(205);
// EXTERNAL MODULE: ./src/components/marketplace/property/SimilarListings.tsx
var SimilarListings = __webpack_require__(72199);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
;// CONCATENATED MODULE: ./src/components/marketplace/directory/CityLinkList.tsx


var CityLinkList = function(param) {
    var cities = param.cities;
    if (!cities.length) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        tag: "section",
        "aria-label": "Cities with homes for sale",
        py: "$8x",
        flex: 1,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            px: "$4x",
            mx: "auto",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h2",
                    typography: "$headerSmall",
                    mb: "$6x",
                    children: "Cities with homes for sale"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    tag: "ul",
                    style: {
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                        gap: "1rem",
                        listStyle: "none",
                        padding: 0,
                        margin: 0
                    },
                    children: cities.filter(function(city) {
                        return city.count > 0;
                    }).sort(function(a, b) {
                        return a.name.localeCompare(b.name);
                    }).map(function(city) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            tag: "li",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* Link */.r, {
                                analyticsName: "city-directory-link",
                                href: "/homes/".concat(city.slug),
                                variant: "primary",
                                children: [
                                    city.name,
                                    ", ",
                                    city.state,
                                    " (",
                                    city.count,
                                    ")"
                                ]
                            })
                        }, city.slug);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/Dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(62742);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/marketplace/directory/NearMeButton.tsx


var formatCityName = function(slug) {
    return slug.split("-").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");
};
var CityNearMeButton = function(param) {
    var city = param.city, count = param.count;
    if (!city || !count) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
            analyticsName: "zero-homes-disabled-placeholder",
            size: "medium",
            variant: "secondary",
            label: "No homes near you",
            disabled: true
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        analyticsName: "count-homes-near-you",
        size: "medium",
        href: "/homes/".concat(city),
        variant: "primary",
        label: "".concat(count, " ").concat(count === 1 ? "home" : "homes", " near you in ").concat(formatCityName(city))
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/directory/DirectoryHeader.tsx




var DropdownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16vciw70"
})("min-width:150px;> div{gap:0 !important;}label{display:none !important;}");
var DirectoryHeader = function(param) {
    var pageType = param.pageType, locationName = param.locationName, locationSlug = param.locationSlug, totalCount = param.totalCount, stateName = param.stateName, displayingCity = param.displayingCity, availableCities = param.availableCities, nearMeCity = param.nearMeCity, nearMeCityCount = param.nearMeCityCount, marketSlug = param.marketSlug;
    var hasMultipleCities = availableCities && availableCities.length > 1;
    var StateHeader = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                    tag: "h1",
                    typography: "$headerLarge",
                    mb: "$2x",
                    textAlign: "center",
                    children: [
                        "Homes for Sale in ",
                        locationName
                    ]
                }),
                displayingCity && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                    tag: "h2",
                    typography: "$headerSmall",
                    mb: "$4x",
                    textAlign: "center",
                    children: [
                        "Top properties in ",
                        displayingCity
                    ]
                })
            ]
        });
    };
    var CityHeader = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
            tag: "h1",
            typography: "$headerLarge",
            mb: "$4x",
            textAlign: "center",
            children: [
                totalCount,
                " ",
                totalCount === 1 ? "Home" : "Homes",
                " for Sale in ",
                locationName,
                stateName && ", ".concat(stateName)
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        mb: "$2x",
        pb: "$2x",
        style: {
            position: "sticky"
        },
        top: 0,
        backgroundColor: "$backgroundPrimary",
        zIndex: 1,
        children: [
            pageType === "state" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateHeader, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CityHeader, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                mb: "$2x",
                gap: "$8x",
                $smallerThanLG: {
                    gap: "$4x"
                },
                $smallerThanMD: {
                    flexDirection: hasMultipleCities ? "column" : "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CityNearMeButton, {
                        city: nearMeCity,
                        count: nearMeCityCount
                    }),
                    hasMultipleCities && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: "Top homes in",
                            size: "medium",
                            options: availableCities.map(function(city) {
                                return {
                                    label: city.name,
                                    value: city.slug
                                };
                            }),
                            prefilledValue: marketSlug,
                            onValueChange: function(citySlug) {
                                window.location.href = "/homes/state/".concat(locationSlug, "?city=").concat(citySlug);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "see-map-link",
                        href: "/homes/".concat(marketSlug),
                        variant: "primary",
                        size: "medium",
                        label: "View Map"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/helpers/globals.ts
var helpers_globals = __webpack_require__(63631);
;// CONCATENATED MODULE: ./src/components/marketplace/directory/DirectorySeoHead.tsx



var DirectorySeoHead = function(param) {
    var canonicalUrl = param.canonicalUrl, listings = param.listings, locationName = param.locationName, pageType = param.pageType, seoDescription = param.seoDescription, seoTitle = param.seoTitle, stateName = param.stateName, totalCount = param.totalCount;
    var ref, ref1;
    var firstListingImage = (ref = listings[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.photos) === null || ref1 === void 0 ? void 0 : ref1[0];
    var itemListSchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: listings.slice(0, 10).map(function(listing, idx) {
            return {
                "@type": "ListItem",
                position: idx + 1,
                item: {
                    "@type": "Product",
                    name: listing.fullAddress,
                    url: "".concat(helpers_globals/* HOMEPAGE_URL */.j_, "/properties/").concat(listing.slug, "/aid_").concat(listing.addressToken),
                    offers: {
                        "@type": "Offer",
                        price: listing.listPrice,
                        priceCurrency: "USD"
                    }
                }
            };
        })
    };
    var breadcrumbItems = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Homes",
            item: "".concat(helpers_globals/* HOMEPAGE_URL */.j_, "/homes")
        }, 
    ];
    if (pageType === "city" && stateName) {
        breadcrumbItems.push({
            "@type": "ListItem",
            position: 2,
            name: stateName,
            item: "".concat(helpers_globals/* HOMEPAGE_URL */.j_, "/homes/state/").concat(stateName.toLowerCase().replace(/ /g, "-"))
        });
        breadcrumbItems.push({
            "@type": "ListItem",
            position: 3,
            name: locationName,
            item: canonicalUrl
        });
    } else {
        breadcrumbItems.push({
            "@type": "ListItem",
            position: 2,
            name: locationName,
            item: canonicalUrl
        });
    }
    var breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbItems
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: seoTitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: seoDescription
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: seoTitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: seoDescription
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            firstListingImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: firstListingImage
            }),
            listings.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(itemListSchema)
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbSchema)
                }
            }),
            totalCount === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/directory/StateLinkList.tsx


var StateLinkList = function(param) {
    var states = param.states;
    if (!states.length) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        tag: "section",
        "aria-label": "States with homes for sale",
        py: "$8x",
        flex: 1,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            px: "$4x",
            mx: "auto",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h2",
                    typography: "$headerSmall",
                    mb: "$6x",
                    children: "States with homes for sale"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    tag: "ul",
                    style: {
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                        gap: "1rem",
                        listStyle: "none",
                        padding: 0,
                        margin: 0
                    },
                    children: states.filter(function(state) {
                        return state.count > 0;
                    }).sort(function(a, b) {
                        return a.name.localeCompare(b.name);
                    }).map(function(state) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            tag: "li",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* Link */.r, {
                                analyticsName: "state-directory-link",
                                href: "/homes/state/".concat(state.slug),
                                variant: "primary",
                                children: [
                                    state.name,
                                    " (",
                                    state.count,
                                    ")"
                                ]
                            })
                        }, state.slug);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/directory/DirectoryTemplate.tsx










var PAGE_SIZE = 30;
var DirectoryTemplate = function(props) {
    var aiBlurb = props.aiBlurb, availableCities = props.availableCities, canonicalUrl = props.canonicalUrl, citiesWithInventory = props.citiesWithInventory, currentPage = props.currentPage, displayingCity = props.displayingCity, footer = props.footer, header = props.header, listings = props.listings, locationName = props.locationName, locationSlug = props.locationSlug, marketSlug = props.marketSlug, nearMeCity = props.nearMeCity, nearMeCityCount = props.nearMeCityCount, nextPage = props.nextPage, pageType = props.pageType, seoDescription = props.seoDescription, seoTitle = props.seoTitle, stateName = props.stateName, statesWithInventory = props.statesWithInventory, totalCount = props.totalCount;
    var router = (0,next_router.useRouter)();
    // Use API data directly, only calculate totalPages for display
    var totalPages = Math.ceil(totalCount / PAGE_SIZE);
    var showPagination = totalCount > PAGE_SIZE;
    var hasPreviousPage = currentPage > 1;
    var hasNextPage = nextPage != null;
    // Build pagination URL preserving existing query params (like city selection)
    var buildPageUrl = function(page) {
        var params = new URLSearchParams();
        // Copy query params except dynamic route segments
        Object.entries(router.query).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (key !== "state" && key !== "market" && typeof value === "string") {
                params.set(key, value);
            }
        });
        params.set("page", String(page));
        var basePath = router.asPath.split("?")[0];
        return "".concat(basePath, "?").concat(params.toString());
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DirectorySeoHead, {
                canonicalUrl: canonicalUrl,
                listings: listings,
                locationName: locationName,
                pageType: pageType,
                seoDescription: seoDescription,
                seoTitle: seoTitle,
                stateName: stateName,
                totalCount: totalCount
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMapLayout/* default */.Z, {
                header: header,
                footer: footer !== null && footer !== void 0 ? footer : undefined,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    py: "$8x",
                    px: "$4x",
                    height: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        maxWidth: 1200,
                        mx: "auto",
                        height: "100%",
                        overflow: "scroll",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DirectoryHeader, {
                                pageType: pageType,
                                locationName: locationName,
                                locationSlug: locationSlug,
                                totalCount: totalCount,
                                stateName: stateName,
                                displayingCity: displayingCity,
                                availableCities: availableCities,
                                nearMeCity: nearMeCity,
                                nearMeCityCount: nearMeCityCount,
                                marketSlug: marketSlug || (availableCities === null || availableCities === void 0 ? void 0 : availableCities[0].slug)
                            }),
                            aiBlurb && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyLarge",
                                mb: "$4x",
                                children: aiBlurb
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                flexDirection: "row",
                                flexWrap: "wrap",
                                mb: "$8x",
                                style: {
                                    gap: "1.5rem"
                                },
                                children: listings.map(function(listing, index) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        width: "100%",
                                        $largerThanSM: {
                                            width: "calc((100% - 1.5rem) / 2)"
                                        },
                                        $largerThanMD: {
                                            width: "calc((100% - 1.5rem) / 2)"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimilarListings/* ListingCard */.d, {
                                            listing: listing
                                        })
                                    }, "".concat(listing.slug, "-").concat(index));
                                })
                            }),
                            showPagination && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "$4x",
                                mb: "$8x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ChevronBackButton */.jd, {
                                        analyticsName: "directory-previous-page",
                                        size: "medium",
                                        href: buildPageUrl(currentPage - 1),
                                        disabled: !hasPreviousPage,
                                        iconLabel: "Go to previous page"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodyMedium",
                                        children: [
                                            "Page ",
                                            currentPage,
                                            " of ",
                                            totalPages
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ChevronForwardButton */.bB, {
                                        analyticsName: "directory-next-page",
                                        size: "medium",
                                        href: buildPageUrl(currentPage + 1),
                                        disabled: !hasNextPage,
                                        iconLabel: "Go to next page"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                display: "flex",
                                flexDirection: "row",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CityLinkList, {
                                        cities: citiesWithInventory
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateLinkList, {
                                        states: statesWithInventory
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/directory/EmptyStateNearby.tsx



var EmptyStateNearby = function(param) {
    var stateName = param.stateName, nearestStates = param.nearestStates, allStates = param.allStates;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                py: "$12x",
                px: "$6x",
                alignItems: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    maxWidth: 800,
                    width: "100%",
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "h1",
                            typography: "$headerLarge",
                            mb: "$6x",
                            children: [
                                "Homes for Sale in ",
                                stateName
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodyLarge",
                            mb: "$8x",
                            children: [
                                "No homes available in ",
                                stateName,
                                " yet. Browse these homes in nearby states:"
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            flexDirection: "row",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            mb: "$8x",
                            style: {
                                gap: "1rem"
                            },
                            children: nearestStates.length > 0 ? nearestStates.map(function(state) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                    analyticsName: "nearby-state-link",
                                    href: "/homes/state/".concat(state.slug),
                                    variant: "secondary",
                                    size: "large",
                                    label: "".concat(state.name, " (").concat(state.count, " ").concat(state.count === 1 ? "home" : "homes", ")")
                                }, state.slug);
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                analyticsName: "view-all-markets",
                                href: "/homes",
                                variant: "primary",
                                size: "large",
                                label: "View all available markets"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            mt: "$12x",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                analyticsName: "view-all-markets-footer",
                                href: "/homes",
                                variant: "secondary",
                                size: "medium",
                                label: "View all available markets →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateLinkList, {
                states: allStates
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/homes/state/[state].tsx
// eslint-disable-next-line no-restricted-imports




var StateDirectoryPage = function(props) {
    if (props.isEmpty && props.nearestStates) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyStateNearby, {
            stateName: props.stateDisplayName,
            nearestStates: props.nearestStates,
            allStates: props.statesWithInventory
        });
    }
    var seoTitle = "Homes for Sale in ".concat(props.stateDisplayName, " | Opendoor");
    var seoDescription = "Browse homes for sale across ".concat(props.stateDisplayName, ". Find houses, condos, and town homes in cities throughout the state with Opendoor.");
    var canonicalUrl = "".concat(globals/* COSMOS_URL */.EQ, "/homes/state/").concat(props.state);
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DirectoryTemplate, {
        pageType: "state",
        locationName: props.stateDisplayName,
        locationSlug: props.state,
        listings: props.listings,
        totalCount: props.totalCount,
        currentPage: props.currentPage,
        nextPage: props.nextPage,
        citiesWithInventory: props.citiesWithInventory,
        statesWithInventory: props.statesWithInventory,
        nearMeCity: props === null || props === void 0 ? void 0 : props.nearMeCity,
        nearMeCityCount: props === null || props === void 0 ? void 0 : props.nearMeCityCount,
        aiBlurb: props === null || props === void 0 ? void 0 : props.aiBlurb,
        seoTitle: seoTitle,
        seoDescription: seoDescription,
        canonicalUrl: canonicalUrl,
        displayingCity: props === null || props === void 0 ? void 0 : props.displayingCity,
        availableCities: props === null || props === void 0 ? void 0 : props.availableCities,
        footer: props === null || props === void 0 ? void 0 : props.footer,
        header: props === null || props === void 0 ? void 0 : props.header,
        marketSlug: (ref = props === null || props === void 0 ? void 0 : props.marketSlug) !== null && ref !== void 0 ? ref : undefined
    });
};
var __N_SSP = true;
/* harmony default export */ var _state_ = (StateDirectoryPage);


/***/ }),

/***/ 36916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ PropertyCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/marketplace/PropertyCard/PropertyCard.mjs
function cov_2hvthg5jk2() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx";
    var hash = "e7cc4efcf932e0be8f30eddefe086b5019605309";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 21,
                    column: 57
                },
                end: {
                    line: 121,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 35,
                    column: 2
                },
                end: {
                    line: 120,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 21,
                        column: 57
                    },
                    end: {
                        line: 21,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 6
                    },
                    end: {
                        line: 121,
                        column: 1
                    }
                },
                line: 34
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 50,
                        column: 11
                    },
                    end: {
                        line: 54,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 50,
                            column: 11
                        },
                        end: {
                            line: 50,
                            column: 16
                        }
                    },
                    {
                        start: {
                            line: 51,
                            column: 12
                        },
                        end: {
                            line: 53,
                            column: 19
                        }
                    }
                ],
                line: 50
            },
            "1": {
                loc: {
                    start: {
                        line: 55,
                        column: 11
                    },
                    end: {
                        line: 59,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 55,
                            column: 11
                        },
                        end: {
                            line: 55,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 56,
                            column: 12
                        },
                        end: {
                            line: 58,
                            column: 19
                        }
                    }
                ],
                line: 55
            },
            "2": {
                loc: {
                    start: {
                        line: 61,
                        column: 9
                    },
                    end: {
                        line: 72,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 61,
                            column: 9
                        },
                        end: {
                            line: 61,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 62,
                            column: 10
                        },
                        end: {
                            line: 71,
                            column: 16
                        }
                    }
                ],
                line: 61
            },
            "3": {
                loc: {
                    start: {
                        line: 64,
                        column: 27
                    },
                    end: {
                        line: 64,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 64,
                            column: 27
                        },
                        end: {
                            line: 64,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 64,
                            column: 41
                        },
                        end: {
                            line: 64,
                            column: 46
                        }
                    }
                ],
                line: 64
            },
            "4": {
                loc: {
                    start: {
                        line: 77,
                        column: 13
                    },
                    end: {
                        line: 77,
                        column: 34
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 77,
                            column: 13
                        },
                        end: {
                            line: 77,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 77,
                            column: 21
                        },
                        end: {
                            line: 77,
                            column: 34
                        }
                    }
                ],
                line: 77
            },
            "5": {
                loc: {
                    start: {
                        line: 79,
                        column: 11
                    },
                    end: {
                        line: 88,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 79,
                            column: 11
                        },
                        end: {
                            line: 79,
                            column: 16
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 12
                        },
                        end: {
                            line: 87,
                            column: 15
                        }
                    }
                ],
                line: 79
            },
            "6": {
                loc: {
                    start: {
                        line: 89,
                        column: 11
                    },
                    end: {
                        line: 98,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 89,
                            column: 11
                        },
                        end: {
                            line: 89,
                            column: 15
                        }
                    },
                    {
                        start: {
                            line: 90,
                            column: 12
                        },
                        end: {
                            line: 97,
                            column: 15
                        }
                    }
                ],
                line: 89
            },
            "7": {
                loc: {
                    start: {
                        line: 99,
                        column: 11
                    },
                    end: {
                        line: 108,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 99,
                            column: 11
                        },
                        end: {
                            line: 99,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 100,
                            column: 12
                        },
                        end: {
                            line: 107,
                            column: 15
                        }
                    }
                ],
                line: 99
            },
            "8": {
                loc: {
                    start: {
                        line: 112,
                        column: 13
                    },
                    end: {
                        line: 112,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 112,
                            column: 13
                        },
                        end: {
                            line: 112,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 112,
                            column: 29
                        },
                        end: {
                            line: 112,
                            column: 48
                        }
                    }
                ],
                line: 112
            },
            "9": {
                loc: {
                    start: {
                        line: 115,
                        column: 13
                    },
                    end: {
                        line: 115,
                        column: 30
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 13
                        },
                        end: {
                            line: 115,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 115,
                            column: 21
                        },
                        end: {
                            line: 115,
                            column: 30
                        }
                    }
                ],
                line: 115
            }
        },
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "e7cc4efcf932e0be8f30eddefe086b5019605309"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2hvthg5jk2 = function cov_2hvthg5jk2() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2hvthg5jk2();



cov_2hvthg5jk2().s[0]++;
var PropertyCard = function PropertyCard(_ref) {
    var _ref2;
    var beds = _ref.beds, baths = _ref.baths, city = _ref.city, dwellingType = _ref.dwellingType, estimatedMonthlyPayment = _ref.estimatedMonthlyPayment, href = _ref.href, isFavorite = _ref.isFavorite, neighborhood = _ref.neighborhood, onFavoritePress = _ref.onFavoritePress, photoUrl = _ref.photoUrl, price = _ref.price, sqft = _ref.sqft;
    cov_2hvthg5jk2().f[0]++;
    cov_2hvthg5jk2().s[1]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: href,
        analyticsName: "marketplace-property-card-image-link"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        mb: "$8x",
        borderRadius: "$8x",
        overflow: "hidden"
    }, /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        alt: "Main view of property",
        borderRadius: "$8x",
        source: {
            uri: photoUrl
        },
        resizeMode: "cover",
        aspectRatio: 16 / 9
    }))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 8
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline"
    }, (cov_2hvthg5jk2().b[0][0]++, price) && (cov_2hvthg5jk2().b[0][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        color: "$contentPrimary",
        typography: "$labelXlarge",
        mr: 4
    }, (0,currencyHelpers/* formatCurrency */.xG)(price))), (cov_2hvthg5jk2().b[1][0]++, estimatedMonthlyPayment) && (cov_2hvthg5jk2().b[1][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        color: "$contentTertiary",
        typography: "$bodySmall",
        ml: 4
    }, (0,currencyHelpers/* formatCurrency */.xG)(estimatedMonthlyPayment), "/month est."))), (cov_2hvthg5jk2().b[2][0]++, onFavoritePress) && (cov_2hvthg5jk2().b[2][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        alignSelf: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ react.createElement(IconButton/* FavoriteButton */._6, {
        isFavorited: (_ref2 = (cov_2hvthg5jk2().b[3][0]++, isFavorite)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2hvthg5jk2().b[3][1]++, false),
        analyticsName: "marketplace-property-card-favorite-button",
        onPress: onFavoritePress,
        size: "small",
        variant: "default",
        alignSelf: "center"
    })))), /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: href,
        analyticsName: "marketplace-property-card-info-link"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline",
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[4][0]++, beds) && (cov_2hvthg5jk2().b[4][1]++, "".concat(beds, " bds"))), (cov_2hvthg5jk2().b[5][0]++, baths) && (cov_2hvthg5jk2().b[5][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, baths, " ba"))), (cov_2hvthg5jk2().b[6][0]++, sqft) && (cov_2hvthg5jk2().b[6][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, sqft.toLocaleString(), " sqft"))), (cov_2hvthg5jk2().b[7][0]++, dwellingType) && (cov_2hvthg5jk2().b[7][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, dwellingType)))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        mr: "$1x",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[8][0]++, neighborhood) && (cov_2hvthg5jk2().b[8][1]++, "".concat(neighborhood, ", "))), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        mr: "$1x",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[9][0]++, city) && (cov_2hvthg5jk2().b[9][1]++, "".concat(city))))));
}; //# sourceMappingURL=PropertyCard.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/marketplace/PropertyCard/index.mjs
function cov_hgnyifubm() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts";
    var hash = "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_hgnyifubm = function cov_hgnyifubm() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_hgnyifubm();
 //# sourceMappingURL=index.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5527,6852,6523,9652,6398,2864,4746,7387,2949,7093,8704,1861,5675,3805,7166,4991,8268,9872,205,9774,2888,179], function() { return __webpack_exec__(64815); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);